<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" :width="width" :height="height"><g stroke-linecap="round" stroke-linejoin="round" :stroke-width="strokewidth" :fill="_secondaryfill" :stroke="_secondaryfill"><line fill="none" x1="20.354" y1="14.697" x2="11.541" y2="5.884"></line> <line fill="none" x1="5.884" y1="11.541" x2="14.698" y2="20.354"></line> <line fill="none" x1="33.303" y1="20.354" x2="42.116" y2="11.541"></line> <line fill="none" x1="36.459" y1="5.884" x2="27.646" y2="14.698"></line> <line fill="none" x1="27.646" y1="33.303" x2="36.459" y2="42.116"></line> <line fill="none" x1="42.116" y1="36.459" x2="33.302" y2="27.646"></line> <line fill="none" x1="14.697" y1="27.646" x2="5.884" y2="36.459"></line> <line fill="none" x1="11.541" y1="42.116" x2="20.354" y2="33.302"></line> <ellipse transform="matrix(0.7071 -0.7071 0.7071 0.7071 -9.9411 24)" fill="none" cx="24" cy="24" rx="22" ry="22" :stroke="fill"></ellipse> <ellipse transform="matrix(0.7071 -0.7071 0.7071 0.7071 -9.9411 24)" fill="none" cx="24" cy="24" rx="10" ry="10" :stroke="fill"></ellipse></g></svg></template>

<script>
export default {
	props: {
		width: {
			type: [Number, String],
			default: "100%"
		},
		height: {
			type: [Number, String],
			default: "100%"
		},
		strokewidth: {
			type: [Number, String],
			default: 1
		},
		fill: {
			type: String,
			default: "currentColor"
		},
		secondaryfill: {
			type: String
		}
	},
	computed: {
		_secondaryfill: function () {
			return this.secondaryfill || this.fill
		}
	}
}
</script>